'use strict';

import {EwSiteApp} from "../../app/ewsiteapp.js";

import {ApplicationListSiteCtrl} from "./applicationlistsitectrl.js";
EwSiteApp.controller('ApplicationListSiteCtrl', ["$scope", "$http", "$filter", "$timeout", "$locale", "jsDataService", ApplicationListSiteCtrl]);

import {ApplicationInfoCtrl} from "./applicationinfoctrl.js";
EwSiteApp.controller('ApplicationInfoCtrl', ["$scope", "$filter", "jsDataService", "$mdDialog", ApplicationInfoCtrl]);

import {PdfDownloadCtrl} from "./pdfdownloadctrl.js";
EwSiteApp.controller('PdfDownloadCtrl', ["$scope", "$http", "notify", PdfDownloadCtrl]);

import {ApplicationResponsibleCtrl} from "./applicationresponsiblectrl.js";
EwSiteApp.controller('ApplicationResponsibleCtrl', ["$scope", "$filter", "jsDataService", "$mdDialog", ApplicationResponsibleCtrl]);

import {ApplicationEvaluationCtrl} from "./applicationevaluationctrl.js";
EwSiteApp.controller('ApplicationEvaluationCtrl', ["$scope", "$filter", "jsDataService", "$mdDialog", ApplicationEvaluationCtrl]);

import {ApplicationAssessmentCtrl} from "./applicationassessmentctrl";
EwSiteApp.controller('ApplicationAssessmentCtrl', ["$scope", "$filter", "jsDataService", "$mdDialog", ApplicationAssessmentCtrl]);

import {EvaluationAdmeliCtrl} from "./evaluationadmelictrl.js";
EwSiteApp.controller('EvaluationAdmeliCtrl', ["$scope", "$filter", "$timeout", "$mdDialog", "jsDataService", "notify", EvaluationAdmeliCtrl]);

import {EvaluationAwrcriCtrl} from "./evaluationawrcrictrl.js";
EwSiteApp.controller('EvaluationAwrcriCtrl', ["$scope", "$filter", "$timeout", "$mdDialog", "jsDataService", "notify", EvaluationAwrcriCtrl]);

import {EvaluationCosolidationCtrl} from "./evaluationconsolidationctrl.js";
EwSiteApp.controller('EvaluationCosolidationCtrl', ["$scope", "$filter", "$timeout", "$mdDialog", "jsDataService", "notify", EvaluationCosolidationCtrl]);

import {ApplicationResolutionCtrl} from "./applicationresolutionctrl.js";
EwSiteApp.controller('ApplicationResolutionCtrl', ["$scope", "$filter", "$timeout", "$mdDialog", "jsDataService", "notify", ApplicationResolutionCtrl]);

import {ConsolidationReportGenerateCtrl} from "./generatereportctrl.js";
EwSiteApp.controller('ConsolidationReportGenerateCtrl', ["$scope", "$http", "notify", ConsolidationReportGenerateCtrl]);
